import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Outlet } from "react-router-dom";
import { User } from '../interfaces';
import { UserContext } from '../userContext';

import { Navbar, Alignment, AnchorButton, Button, Popover, Menu, MenuItem, PopoverPosition, MenuDivider, Divider } from '@blueprintjs/core';

const version = "v0.1.0"

function Root() {
  const [user, setUser] = useState<null | User>(null);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/me`)
      .then((resp) => {
        const user = resp.data
        setUser({username: user['username'], id: user['id']})
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  return (
    <div>
      <UserContext.Provider value={user}>
        <Navbar>
          <Navbar.Group align={Alignment.LEFT} >
            <Navbar.Heading>AC6 Garage</Navbar.Heading>
            <Navbar.Divider />
            <AnchorButton href="/" text="Builds" minimal />
            <AnchorButton href="/garage" text="Garage" minimal />
          </Navbar.Group>
          <Navbar.Group align={Alignment.RIGHT} >
            {user ?
              <Popover
                interactionKind="click"
                content={
                  <Menu>
                    <MenuItem
                      onClick={() => window.open(`/user/${user.id}/builds`, "_self")}
                      text="My builds"/>
                    <MenuDivider />
                    <MenuItem
                      onClick={() => axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/logout`)
                        .then(_ =>  window.open("/", "_self"))
                      }
                      text="Logout"
                      icon="log-out" />
                  </Menu>
                }
                position={PopoverPosition.BOTTOM_RIGHT}
                minimal>
                <Button text={user.username} rightIcon="symbol-triangle-down" minimal />
              </Popover>
              :
              <AnchorButton intent="primary" href="/login" text="Login" />
            }
          </Navbar.Group>
        </Navbar>
        <Outlet />
      </UserContext.Provider>
      <div style={{ position: "fixed", left: 0, bottom: 0, width: "100%", display: "flex", justifyContent: "flex-end", background: "white" }}>
        <AnchorButton href="https://discord.com/channels/1150782641663131799/1150782641663131803" text="Contact" minimal />
        <Divider />
        <span style={{ display: "flex", alignItems: "center", padding: "10px" }}>{version}</span>
      </div>
    </div>
  );
}

export default Root;